import { render, staticRenderFns } from "./SetOrderStatusView.vue?vue&type=template&id=15ad7015&scoped=true&"
import script from "./SetOrderStatusView.vue?vue&type=script&lang=js&"
export * from "./SetOrderStatusView.vue?vue&type=script&lang=js&"
import style0 from "./SetOrderStatusView.vue?vue&type=style&index=0&id=15ad7015&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad7015",
  null
  
)

export default component.exports